import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../../localization/strings"
import { IUnitItem } from "../../../models"
import * as utils from "../../../helpers/utils"
interface IProps {
    handleAdd(unit: IUnitItem): void
    handleClose(): void
}
interface IState {
    unitName: string
    errorUnitName: string
}

export default class AddScheduleBudgetUnitDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            unitName: "",
            errorUnitName: "",
        }
        autobind(this)
    }

    handleAdd() {
        if (!this.checkValidate()) return
        this.props.handleAdd({
            Id: utils.guid(),
            Name: this.state.unitName.trim()
        })
    }

    checkValidate() {
        let isValidate = true
        if (this.state.unitName.trim()) {
            this.setState({ errorUnitName: "" })
        }
        else {
            isValidate = false
            this.setState({ errorUnitName: strings.This_field_is_required })
        }
        return isValidate
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Add_Unit}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    <FlatButton
                        label={strings.Add}
                        primary
                        onTouchTap={this.handleAdd}
                    />
                ]}
            >
                <hr />
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <div style={{ width: "100%" }}>
                        <div style={{ gridColumn: 1 }}>
                            <TextField
                                data-intercom-target={"Schedule-Budget-Unit-Name"}
                                floatingLabelText={strings.Unit_Name}
                                value={this.state.unitName}
                                onChange={(e, value) => this.setState({ unitName: value }, () => this.checkValidate())}
                                errorText={this.state.errorUnitName}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}